import React, { useCallback, useEffect, useState } from "react";
import {
  ArtifactType,
  ContentActionType,
  ContentState,
  ContentSubstate,
  CreatorArtifactType,
  getContentStatesForAction,
  getContentStatusString,
  SKArtifact,
  TopicTypeString,
} from "../../models/SKArtifact";
import { Tier, ActionItem } from "../../models/SKArtifact";
import ActionPopup from "../../components/ActionPopup";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteArtifact,
  fetchMyArtifacts,
  duplicateArtifact,
  updateArtifact,
  updateArtifactStatus,
  getCountsCreatorContent,
} from "../../api/artifacts/atrifactService";

import ContainerNavigation from "../../components/ContainerNavigation";
import Loader from "../../components/Loader";
import dayjs from "dayjs";
import { capitalizeFirstLetter, formatAttributeValue, getLanguageName } from "../../utils/stringFunctions";
import SelectTypes from "./create/Selecttypes";
import ArtifactStateDialog, { DialoageContent } from "./create/container/components/ArtifactStateDialog";
import { useAuth } from "../../context/AuthContext";
import SKPagination, { PaginationObject } from "../../components/SKPagination";
import { Pagination } from "../../api/enums";
import { QueryDocumentSnapshot } from "firebase/firestore";
import APILoader from "../../components/APILoader";
import TableHeader from "../../components/table/TableHeader";
import { useNavigationBar } from "../../context/NavigationContext";
import { useUpdateList } from "../contentModeration/UpdateListContext";
import LoadingPopup from "../channels/create/LoadingPopup";

interface ActionOnItem {
  itemid: string;
  action: ActionItem;
}

type SKArtifactKey = keyof SKArtifact;
interface ArtifactTableHeader {
  key: SKArtifactKey;
  label: string;
  span: number;
  sortable: boolean;
}

const ListArtifact = () => {
  // const [activePopupId, setActivePopupId] = useState<number | null>(null);
  const [artifacts, setArtifacts] = useState<SKArtifact[] | null>([]);
  const [tab, setTab] = useState<CreatorArtifactType>(CreatorArtifactType.Draft);
  const [loading, setLoading] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);
  const [paginationObject, setPaginationObject] = useState<PaginationObject | null>(null);
  const [firstDocumentId, setFirstDocumentId] = useState<string | undefined>(undefined);
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: "asc" | "desc" } | undefined>(undefined);
  const [listCount, setListCount] = useState<Record<CreatorArtifactType, number>>({
    [CreatorArtifactType.Draft]: 0,
    [CreatorArtifactType.Active]: 0,
    [CreatorArtifactType.Review]: 0,
    [CreatorArtifactType.Withdrawn]: 0,
    [CreatorArtifactType.Rejected]: 0,
  });

  const { setUpdateContentListFunction } = useUpdateList();
  const { backgroundLocation, showChildRouteAsModal } = useNavigationBar();

  useEffect(() => {
    showChildRouteAsModal(true);

    return () => {
      showChildRouteAsModal(false);
    };
  }, []);

  const headers = [
    { key: "title", label: "Title", span: 3, sortable: true },
    { key: "type", label: "Type", span: 2, sortable: false },
    { key: "tier", label: "Tier", span: 2, sortable: false }, // Non-sortable column
    { key: "createdDate", label: "Date", span: 3, sortable: false },
    { key: "status", label: "State", span: 2, sortable: false }, // Non-sortable column
    // { key: "", label: "", span: 1, sortable: false }, // Non-sortable column
  ];

  const headers2: ArtifactTableHeader[] = [
    // { key: "action", label: "Action", span: 1, sortable: false }, // Non-sortable column
    { key: "title", label: "Title", span: 1, sortable: false },
    { key: "type", label: "Type", span: 1, sortable: false },
    { key: "channelName", label: "Channel", span: 1, sortable: false }, // Non-sortable column

    { key: "lastReportedDate", label: "Last Report", span: 1, sortable: false },
    { key: "reportCount", label: "Reports", span: 1, sortable: false },
    { key: "createdDate", label: "Submitted", span: 1, sortable: false },
    { key: "lastActivityDate", label: "Last Activity", span: 1, sortable: false },

    { key: "language", label: "Language", span: 1, sortable: false },
    { key: "topic", label: "Topic", span: 1, sortable: false }, // Non-sortable column
    // { key: "age", label: "Age", span: 1, sortable: false }, // Non-sortable column
    { key: "status", label: "Status", span: 1, sortable: false }, // Non-sortable column

    { key: "loveCount", label: "Hearts", span: 1, sortable: false },
    { key: "likeCount", label: "Likes", span: 1, sortable: false },
    { key: "bookmarkCount", label: "Bookmarks", span: 1, sortable: false },
    { key: "viewCount", label: "Views", span: 1, sortable: false },
    { key: "shareCount", label: "Shares", span: 1, sortable: false },
  ];

  const getFormattedValue = (data: SKArtifact, key: SKArtifactKey) => {
    switch (key) {
      case "createdDate":
      case "lastReportedDate":
      case "lastActivityDate":
      case "approvedDate":
        return data[key] ? formatAttributeValue(data[key]) : "—";
      case "status":
        return getContentStatusString(data.status, data.subStatus);
      case "language":
        return data.language ? getLanguageName(data.language) : "—";
      case "topic":
        return data.topic ? TopicTypeString[data.topic] : "";
      case "age":
        return `Age ${data.age}+`;
      case "loveCount":
      case "likeCount":
      case "bookmarkCount":
      case "reportCount":
      case "viewCount":
        return data[key] || 0;
      case "shareCount":
        return data[key] || 0;
      case "coverMedia":
        return "";
      default:
        return data[key];
    }
  };

  const navigate = useNavigate();
  const authContext = useAuth();
  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const fetchData = async (channelId: string, published: boolean, moveTo: Pagination) => {
  //   try {
  //     let operator = published ? "==" : "!=";
  //     let value = "published"; //published ? "published" : ["draft", "review", "approved", "blocked"];
  //     let currentDoc = moveTo === Pagination.Next || moveTo === Pagination.Last ? paginationObject?.lastDoc : paginationObject?.firstDoc;
  //     var pagination: PaginationObject;
  //     setLoading(true);
  //     if (currentDoc) {
  //       const { docs, ...rest } = await fetchMyArtifacts("status", channelId, operator, value, 10, moveTo, currentDoc);
  //       setArtifacts(docs);
  //       pagination = rest;
  //     } else {
  //       const { docs, ...rest } = await fetchMyArtifacts("status", channelId, operator, value, 10, moveTo);
  //       setArtifacts(docs);
  //       pagination = rest;
  //     }
  //     if (moveTo === Pagination.First) {
  //       setVeryFirstDocument(pagination.firstDoc);
  //     }else{
  //       if(veryFirstDocument && pagination.firstDoc &&  (pagination.firstDoc.id === veryFirstDocument.id)){

  //       }
  //     }
  //     setPaginationObject(pagination);
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchCount = async (contentId: string) => {
    let counts = await getCountsCreatorContent(contentId);
    setListCount(counts);
  };

  useEffect(() => {
    if (authContext?.myChannel?.id) {
      fetchCount(authContext.myChannel.id);
    }
  }, [authContext]);

  const fetchData = async (channelId: string, type: CreatorArtifactType, moveTo: Pagination) => {
    try {
      let operator = "==";
      let pageSize = 10;
      let currentDoc = undefined;
      switch (moveTo) {
        case Pagination.First:
          currentDoc = undefined;
          break;
        case Pagination.Previous:
          currentDoc = paginationObject?.firstDoc;
          break;
        case Pagination.Last:
          currentDoc = paginationObject?.lastDoc;
          switch (type) {
            case CreatorArtifactType.Active:
              pageSize = listCount.Active % pageSize;
              break;
            case CreatorArtifactType.Review:
              pageSize = listCount["In Review"] % pageSize;
              break;
            case CreatorArtifactType.Rejected:
              pageSize = listCount.Rejected % pageSize;
              break;
            case CreatorArtifactType.Withdrawn:
              pageSize = listCount.Withdrawn % pageSize;
              break;
            case CreatorArtifactType.Draft:
              pageSize = listCount.Draft % pageSize;
              break;
          }

          break;
        case Pagination.Next:
          currentDoc = paginationObject?.lastDoc;
          break;
      }
      let fields: string[] = [];
      let values: unknown[] = [];

      switch (type) {
        case CreatorArtifactType.Active:
          fields.push("status");
          values.push(ContentState.ACTIVE);
          break;
        case CreatorArtifactType.Review:
          fields.push("status");
          values.push(ContentState.IN_REVIEW);
          break;
        case CreatorArtifactType.Rejected:
          fields.push("status");
          fields.push("subStatus");
          values.push(ContentState.DRAFT);
          values.push(ContentSubstate.REJECTED);
          break;
        case CreatorArtifactType.Withdrawn:
          fields.push("status");
          fields.push("subStatus");
          values.push(ContentState.DRAFT);
          values.push(ContentSubstate.WITHDRAWN);
          break;
        case CreatorArtifactType.Draft:
          fields.push("status");
          fields.push("subStatus");
          values.push(ContentState.DRAFT);
          values.push(ContentSubstate.NONE);
          break;

        default:
          break;
      }
      setLoading(true);
      const { docs, ...rest } = await fetchMyArtifacts(fields, channelId, operator, values, pageSize, moveTo, currentDoc, false, sortConfig);

      setArtifacts(docs);
      let pagination = rest;

      // Handle veryFirstDocument for disabling the "Prev" and "First" buttons
      if (moveTo === Pagination.First || (pagination.firstDoc && pagination.firstDoc.id === firstDocumentId)) {
        setFirstDocumentId(pagination.firstDoc?.id);
        pagination.hasPrev = false; // Disable previous if we are on the first page
      } else if (moveTo === Pagination.Previous && pagination.firstDoc && pagination.firstDoc.id === firstDocumentId) {
        pagination.hasPrev = false; // Disable previous if we are back on the first page
      }

      setPaginationObject(pagination);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setPaginationObject(null);

    setTimeout(() => {
      if (authContext?.myChannel?.id) {
        fetchData(authContext.myChannel.id, tab, Pagination.First);
      }
    }, 0);
  }, [tab, authContext]);

  // useEffect(() => {
  //   console.log(artifacts);
  // }, [artifacts]);

  const getPopItemsForId = (id: string): ActionItem[] => {
    let content = artifacts?.find(element => element.id === id);
    if (content) {
      return getActionableItems(content);
    }
    return [];
  };

  function getActionableItems(content: SKArtifact): ActionItem[] {
    const actions: { [key in ContentState]: { [key in ContentSubstate]: ActionItem[] } } = {
      ACTIVE: {
        NONE: [ActionItem.reject],
        EDIT_IN_DRAFT: [],
        EDIT_APPROVED: [],
        EDIT_REJECTED: [],
        EDIT_IN_REVIEW: [ActionItem.approve_edit, ActionItem.reject_edit],
        DEACTIVATED: [],
        REJECTED: [],
        WITHDRAWN: [],
      },
      DRAFT: {
        NONE: [ActionItem.submit_for_review, ActionItem.delete],
        EDIT_IN_DRAFT: [],
        EDIT_APPROVED: [],
        EDIT_REJECTED: [],
        EDIT_IN_REVIEW: [],
        DEACTIVATED: [],
        REJECTED: [ActionItem.submit_for_review, ActionItem.delete],
        WITHDRAWN: [ActionItem.submit_for_review, ActionItem.delete],
      },
      IN_REVIEW: {
        NONE: [ActionItem.approve, ActionItem.reject],
        EDIT_IN_DRAFT: [],
        EDIT_APPROVED: [],
        EDIT_REJECTED: [],
        EDIT_IN_REVIEW: [],
        DEACTIVATED: [],
        REJECTED: [],
        WITHDRAWN: [],
      },
    };

    return actions[content.status][content.subStatus] || [];
  }

  // const updateStatus = async (contentId: string, actionItem: ActionItem) => {
  //   switch (actionItem) {
  //     case ActionItem.delete:
  //       await deleteArtifact(contentId);
  //       setArtifacts(prevItems => prevItems!.filter(item => item.id !== contentId));
  //       break;
  //     case ActionItem.duplicate:
  //       let doc = await duplicateArtifact(contentId);
  //       if (artifacts) {
  //         setArtifacts([...artifacts, doc as SKArtifact]);
  //       } else {
  //         setArtifacts([doc as SKArtifact]);
  //       }
  //       break;

  //     case ActionItem.submit_for_review:
  //       await updateArtifactStatus(contentId, ContentState.IN_REVIEW, ContentSubstate.NONE);
  //       updateLocalStatus(contentId, ContentState.IN_REVIEW, ContentSubstate.NONE);
  //       break;

  //     case ActionItem.withdraw:
  //       await updateArtifactStatus(contentId, ContentState.DRAFT, ContentSubstate.WITHDRAWN);
  //       updateLocalStatus(contentId, ContentState.DRAFT, ContentSubstate.WITHDRAWN);
  //       break;
  //   }
  // };

  // const updateSubscription = (contentId: string, tier: Tier) => {
  //   let items = artifacts!.filter(item => {
  //     if (item.id === contentId) {
  //       var neItem = item;
  //       neItem.tier = tier;
  //       return neItem;
  //     } else {
  //       return item;
  //     }
  //   });

  //   setArtifacts(items);
  // };

  // const updateLocalStatus = (contentId: string, status: ContentState, subStatus: ContentSubstate) => {
  //   let items = artifacts!.filter(item => {
  //     if (item.id === contentId) {
  //       var neItem = item;
  //       neItem.status = status;
  //       neItem.subStatus = subStatus;
  //       return neItem;
  //     } else {
  //       return item;
  //     }
  //   });

  //   setArtifacts(items);
  // };

  function getDialogeContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.duplicate:
        return {
          message: "Are you sure you will like to make duplicate of this content?",
          description: "Content will be duplicated and will be in draft state.",
          actionTitle: "Duplicate",
        };
      case ActionItem.submit_for_review:
        return {
          message: "Are you sure to submit this content for Review?",
          description: "Content will be reviewed by reviewer and you can not make any changes till the time.",
          actionTitle: "Submit for Review",
        };
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete this Content?",
          description: "Content will be permanently deleted form the system and you will not be able to recover it.",
          actionTitle: "Delete",
        };
      case ActionItem.withdraw:
        return {
          message: "Are you sure you will like to Withdraw this content?",
          description: "You can submit this content for publishing review again.",
          actionTitle: "Withdraw",
        };
      default:
        return null;
    }
  }
  const editArtifact = async (containerId: string, type: ArtifactType) => {
    console.log("hello");
    navigate("../createContent", { state: { containerId, type } });
  };

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getDialogeContent(actionOnItem?.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);

  const updateContentList = useCallback(
    (contentId: string, newState: ContentState | undefined, newSubstate: ContentSubstate) => {
      // Find the content that matches the contentId

      if (!newState) {
        //delete item with the contentId form atrifacts
        setArtifacts(prev => {
          if (!prev) return null;
          return prev.filter(existingChannel => existingChannel.id !== contentId);
        });
        return;
      }
      const item = artifacts?.find(content => content.id === contentId);

      if (item) {
        // Use the ActionItem to determine the new state and substate
        const oldState = item.status;
        const oldSubstate = item.subStatus;

        // Helper function to map state/substate to ChannelActionType
        const getActionTypeForState = (state: ContentState, substate: ContentSubstate): CreatorArtifactType | null => {
          if (state === ContentState.IN_REVIEW) return CreatorArtifactType.Review;

          if (state === ContentState.ACTIVE) {
            // if (substate === ContentSubstate.EDIT_IN_REVIEW) return CreatorArtifactType.Active;
            return CreatorArtifactType.Active;
          }
          if (state === ContentState.DRAFT) {
            if (substate === ContentSubstate.REJECTED) return CreatorArtifactType.Rejected;
            if (substate === ContentSubstate.WITHDRAWN) return CreatorArtifactType.Withdrawn;
            return CreatorArtifactType.Draft;
          }
          return null;
        };

        // Identify previous and new action types
        const previousType = getActionTypeForState(oldState, oldSubstate);
        const newType = getActionTypeForState(newState, newSubstate);

        // Update list count based on the action
        setListCount(prev => {
          const updatedCounts = { ...prev };

          // Decrement the count for the old action type
          if (previousType && updatedCounts[previousType] > 0) {
            updatedCounts[previousType] -= 1;
          }

          // Increment the count for the new action type
          if (newType && !(oldState === ContentState.ACTIVE && oldSubstate === ContentSubstate.EDIT_IN_REVIEW)) {
            updatedCounts[newType] = (updatedCounts[newType] || 0) + 1;
          }

          return updatedCounts;
        });

        // Update the artifacts state
        setArtifacts(prev => {
          if (!prev) return null;

          return prev.map(existingChannel =>
            existingChannel.id === contentId ? { ...existingChannel, state: newState, substate: newSubstate } : existingChannel
          );
        });
      }

      // Optionally refresh the data for the selected type
      authContext?.myChannel?.id && fetchData(authContext.myChannel.id, tab, Pagination.First);
    },
    [artifacts, tab, setListCount]
  );

  useEffect(() => {
    setUpdateContentListFunction(() => updateContentList);
  }, [setUpdateContentListFunction, updateContentList]);

  useEffect(() => {
    authContext?.myChannel?.id && fetchData(authContext.myChannel.id, tab, Pagination.First);
  }, [sortConfig]);

  const handleSortChange = (config: { key: string; direction: "asc" | "desc" } | undefined) => {
    console.log("Sort Config:", config);
    setSortConfig(config);
  };

  const totalSpan = headers2.reduce((sum, item) => sum + item.span, 0);
  const gridColsClass = `grid-cols-${totalSpan}`; //`grid-cols-[repeat(${totalSpan},_1fr)_auto]`;

  return (
    <div className="flex-1 bg-white">
      <LoadingPopup isLoading={loading} loadingText="Loading" />
      <div className="flex flex-col flex-1 ">
        <SelectTypes isOpen={showCreateModal} onClose={() => setShowCreateModal(false)} />
        {/* <div className="flex flex-row h-[50px] w-full justify-between">
          <div className="float-left text-lg font-bold">Content</div>
          <div className="float-right">
            <Link
              to="../create"
              className="flex items-center justify-center px-3 py-2 text-sm font-normal text-center text-white bg-black rounded-lg"
            >
              <button className="w-full h-full">Create</button>
            </Link>
          </div>
        </div> */}

        {/* {actionOnItem?.action && dialogContent ? (
          <ArtifactStateDialog
            action={actionOnItem?.action}
            onClose={() => setActionOnItem(null)}
            onUpdate={() => {
              const { itemid, action } = actionOnItem;
              setActionOnItem(null);
              const update = async (itemid: string, action: ActionItem) => {
                await updateStatus(itemid, action);
              };
              update(itemid, action);
            }}
            dialogeContent={dialogContent}
          />
        ) : (
          <></>
        )} */}

        <ContainerNavigation
          backArrow={false}
          title={"Content"}
          buttonTitle={"Create"}
          subtitle={"Channel"}
          enableLink={true}
          onBack={() => {}}
          onSearch={() => {}}
          onNext={() => setShowCreateModal(true)} //navigate("../create")}
        />
        <div className="flex gap-[25px] mt-[30px] felx-row overflow-x-auto">
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setTab(CreatorArtifactType.Draft);
            }}
            className={
              (tab === CreatorArtifactType.Draft ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center mx-2 dark:text-black text-nowrap"
            }
          >
            Draft . {listCount.Draft}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setTab(CreatorArtifactType.Review);
            }}
            className={
              (tab === CreatorArtifactType.Review ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center dark:text-black text-nowrap"
            }
          >
            In Review . {listCount["In Review"]}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setTab(CreatorArtifactType.Active);
            }}
            className={
              (tab === CreatorArtifactType.Active ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center dark:text-black text-nowrap"
            }
          >
            Active . {listCount.Active}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setTab(CreatorArtifactType.Withdrawn);
            }}
            className={
              (tab === CreatorArtifactType.Withdrawn ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center dark:text-black text-nowrap"
            }
          >
            Withdrawn . {listCount.Withdrawn}
          </Link>
          <Link
            to={"#"}
            onClick={e => {
              e.preventDefault();
              setTab(CreatorArtifactType.Rejected);
            }}
            className={
              (tab === CreatorArtifactType.Rejected ? " border-black " : " border-white ") +
              "border-b-2 text-lg font-bold flex items-center dark:text-black text-nowrap"
            }
          >
            Rejected . {listCount.Rejected}
          </Link>
        </div>
        <div className="flex flex-col flex-1">
          <div id="xxx" className="flex flex-col p-2 overflow-y-auto h-[calc(100vh-354px)]">
            {/* <TableHeader headers={headers} onSortChange={handleSortChange} /> */}
            <TableHeader headers={headers2} onSortChange={handleSortChange} className={`w-full md:min-w-[980px] ${gridColsClass}`} />
            <div className="hidden thinseparator md:block"></div>
            {/* {loading ? <Loader /> : <></>} */}
            {/* <APILoader loading={loading} /> */}

            {artifacts?.map(content => {
              // console.log("key", content.id);
              return (
                <div
                  key={content.id}
                  onClick={() => navigate(`${content.id}`)}
                  className="pt-2 my-2 group hover:cursor-pointer hover:font-semibold hover:bg-skseparatorgray "
                >
                  {/* Table view for browser  */}
                  <div className="hidden md:block">
                    <div
                      key={content.id}
                      className={`grid md:grid items-center md:min-w-[980px] ${gridColsClass} gap-4 w-full justify-center  border-b-[1px] border-gray-300 pb-3`}
                    >
                      {headers2.map(header => (
                        <div key={header.key} className={`col-span-${header.span} text-sm font-bold capitalize md:text-xs md:font-normal`}>
                          {getFormattedValue(content, header.key)}
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Mobile card view */}
                  <div className="relative py-2 mb-3 border-[1px] border-skseparatorgray rounded-xl md:hidden">
                    <div className="m-2 ">
                      <div className="text-xs text-gray-500">Title</div>
                      <div
                        // to={`${content.id}`}
                        className="flex flex-col text-sm"
                        // onClick={() => editArtifact(content.id!, content.type!)}
                      >
                        {content.title}
                      </div>

                      <div className="gap-2 mt-4 space-y-4 ">
                        <div className="grid grid-cols-2 ">
                          <div className="flex flex-col">
                            <div className="text-xs text-gray-500">Type</div>
                            <div className=" md:text-black">{capitalizeFirstLetter(content.type!)}</div>
                          </div>
                          <div className="flex flex-col ">
                            <div className="text-xs text-gray-500 ">Tier</div>
                            <div className="flex items-center capitalize">{content.tier}</div>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 ">
                          <div className="flex flex-col ">
                            <div className="text-xs text-gray-500 ">Date</div>
                            <div className=" md:text-black">{dayjs(content.createdDate?.toDate()).format("MMM DD, YYYY")}</div>
                          </div>
                          <div className="flex flex-col ">
                            <div className="text-xs text-gray-500 ">State</div>
                            <div className={/*(content.status === State.published ? "font-bold " : "") +*/ "flex items-center capitaliz"}>
                              <span
                                className={(content.status === ContentState.ACTIVE ? "" : "hidden ") + "flex w-2 h-2 bg-green-500 rounded-full me-1"}
                              />
                              {getContentStatusString(content.status, content.subStatus)}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="m-2 md:col-span-1"></div> */}
                      {/* <ActionPopup
                        className="m-2 md:col-span-1"
                        getValues={() => {
                          return getPopItemsForId(content.id);
                        }}
                        onSelect={actionItem => {
                          setActionOnItem({
                            itemid: content.id!,
                            action: actionItem as ActionItem,
                          });
                          //updateStatus(content.id!, actionItem);
                        }}
                      /> */}
                    </div>
                  </div>
                  <div className="hidden thinseparator md:block"></div>
                </div>
              );
            })}
          </div>
        </div>
        {(paginationObject?.hasNext || paginationObject?.hasPrev) && (
          <div className="items-center content-center mx-auto ">
            <SKPagination
              onFirst={() => {
                authContext?.myChannel?.id && fetchData(authContext.myChannel.id, tab, Pagination.First);
              }}
              onLast={() => {
                authContext?.myChannel?.id && fetchData(authContext.myChannel.id, tab, Pagination.Last);
              }}
              onNext={() => {
                authContext?.myChannel?.id && fetchData(authContext.myChannel.id, tab, Pagination.Next);
              }}
              onPrev={() => {
                authContext?.myChannel?.id && fetchData(authContext.myChannel.id, tab, Pagination.Previous);
              }}
              hasNext={paginationObject.hasNext || false}
              hasPrev={paginationObject.hasPrev || false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListArtifact;
